/* TEMPORARY COMPONENT AS PLACEHOLDER FOR SEARCH RESULTS 2026 */

import React from 'react';
import * as styles from './placeholder.style';

export interface PlaceholderProps {
  label: string;
  ticket?: string;
  detail?: string;
  width?: number;
  minHeight?: number;
}

const Placeholder = ({
  label,
  ticket,
  detail,
  width,
  minHeight,
}: PlaceholderProps): JSX.Element => (
  <div
    css={styles.placeholder({ width, minHeight })}
    data-testid={`search-results-2026__placeholder--${label
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')}`}
  >
    {detail && <span css={styles.detail}>{detail}</span>}
    <span css={styles.label}>{label}</span>
    {ticket && <span css={styles.ticket}>{ticket}</span>}
  </div>
);

export default Placeholder;
